import api from './api';

const sujetsApi = {
  // Récupérer les sujets filtrés par concession
  getAll: (concessionId = null) => {
    const params = concessionId ? { concession_id: concessionId } : {};
    return api.get('/sujets', { params });
  },

  // Récupérer tous les sujets avec leurs concessions (admin)
  getAllWithConcessions: () => {
    return api.get('/sujets/all');
  },

  // Créer un sujet
  create: (data) => {
    return api.post('/sujets', {
      nom: data.nom,
      actif: data.actif !== undefined ? data.actif : true,
      concession_ids: data.concession_ids || []
    });
  },

  // Modifier un sujet
  update: (id, data) => {
    return api.put(`/sujets/${id}`, {
      nom: data.nom,
      actif: data.actif !== undefined ? data.actif : true,
      concession_ids: data.concession_ids || []
    });
  },

  // Supprimer un sujet
  delete: (id) => {
    return api.delete(`/sujets/${id}`);
  }
};

export default sujetsApi;